import { MouseEvent } from 'react'
import { useRouter } from 'next/router'
import styled, { css } from 'styled-components'
import { getLimitNumText } from 'components/ActivityListCardItem/module/getLimitNumText'
import Heart from 'svgIcons/Heart'
import useToggleCompanyInterest from '../../../detail/hooks/useToggleCompanyInterest'
import { TCompanyInfoCard } from '../../type/companyInfoCard'

interface IFProps {
  data: TCompanyInfoCard
  checkLogin: (callback?: () => void) => void
  relatedCompanyId?: string
}

const CompanyInfoCardVertical = ({
  data,
  checkLogin,
  relatedCompanyId,
}: IFProps) => {
  const router = useRouter()
  const { toggleCompanyInterest } = useToggleCompanyInterest()

  const handleClickCard = () => {
    router.push(`/company-info/${data.companyInformationId}`)
  }
  const handleClickLike = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation()
    checkLogin(() => {
      toggleCompanyInterest(data.companyId, data.isLiked, relatedCompanyId)
    })
  }
  return (
    <StyledWrapper onClick={handleClickCard}>
      <div className="company-logo-wrapper">
        {data.isHiring && <span className="badge-hiring">채용중</span>}
        <button
          type="button"
          aria-label="관심 설정"
          className="like-button"
          onClick={handleClickLike}
        >
          <Heart isFilled={data.isLiked} />
        </button>
        <img src={data.companyLogo} alt={data.companyName} />
      </div>

      <div className="company-info-wrapper">
        <h3 className="company-name">{data.companyName}</h3>
        <div className="company-type">
          <span>{data.companyType}</span>
          <span>{data.industryType}</span>
        </div>
        <div className="company-stats">
          <span>
            관심설정{' '}
            {getLimitNumText({
              number: data.likesCount,
              limit: 9999,
            })}
          </span>
          <span>
            조회수{' '}
            {getLimitNumText({
              number: data.viewsCount,
              limit: 9999,
            })}
          </span>
        </div>
      </div>
    </StyledWrapper>
  )
}

const StyledWrapper = styled.div`
  ${({ theme }) => css`
    cursor: pointer;

    .company-logo-wrapper {
      box-sizing: border-box;
      width: 100%;
      height: 180px;
      background: ${theme.background.bg_8};
      border: 1px solid ${theme.line.line_3};
      border-radius: 8px;
      padding: 16px;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 16px;

      .badge-hiring {
        position: absolute;
        top: 16px;
        left: 16px;
        background: #f46161;
        color: ${theme.background.bg_8};
        font-size: 12px;
        font-weight: bold;
        border-radius: 6px;
        min-width: 44px;
        height: 24px;
        display: inline-flex;
        justify-content: center;
        align-items: center;
      }

      .like-button {
        position: absolute;
        top: 16px;
        right: 16px;
        font-size: 20px;
        color: #bbb;
        cursor: pointer;
        background: transparent;
        border: none;
      }
      > img {
        max-width: 190px;
        max-height: 120px;
        object-fit: contain;
      }
    }

    .company-info-wrapper {
      .company-name {
        font-size: 16px;
        font-weight: bold;
        line-height: 1.5;
        letter-spacing: -0.64px;
        margin-bottom: 4px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .company-type {
        font-size: 14px;
        line-height: 1.71;
        letter-spacing: -0.56px;
        margin-bottom: 8px;
        & > span:not(:last-child)::after {
          content: '';
          display: inline-block;
          vertical-align: middle;
          margin: 0 5px;
          width: 1px;
          height: 10px;
          background-color: ${theme.line.line_2};
        }
      }
      .company-stats {
        font-size: 13px;
        color: ${theme.color.text_2};
        letter-spacing: -0.52px;
        & > span:not(:last-child)::after {
          content: '';
          display: inline-block;
          vertical-align: middle;
          margin: 0 5px;
          width: 1px;
          height: 10px;
          background-color: ${theme.line.line_2};
        }
      }
    }
  `}
`

export default CompanyInfoCardVertical
